import React, { useState, useEffect } from "react";
import api from "../../services/api";
import LandingHeader from "./LandingHeader";
import LandingFooter from "./Footer";
import VLibras from "./VLibras";
import useSettings from "../../hooks/useSettings";

const DEFAULT_CONTENT = `
<h2>1. Boas práticas operacionais</h2>
<p>Utilize apenas canais oficiais autorizados pelos provedores. Evite listas compradas, disparos em massa sem consentimento e mensagens sensíveis fora de ambientes criptografados.</p>
<h2>2. Limites e automações</h2>
<p>Scripts, bots e integrações devem respeitar limites de requisições e autenticação. Qualquer automação que impacte terceiros negativamente poderá ser suspensa até ajuste.</p>
<h2>3. Conteúdo proibido</h2>
<p>É vedado disseminar spam, phishing, discursos de ódio, informações ilegais ou que violem direitos autorais/registro de marcas. Denúncias podem resultar em suspensão imediata.</p>
<h2>4. Privacidade dos usuários</h2>
<p>Dados de clientes só devem ser coletados com base legal apropriada. Remova informações mediante solicitação e configure políticas de retenção conforme LGPD.</p>
<h2>5. Consequências</h2>
<p>Violações reincidentes podem acarretar limitação de recursos, bloqueio temporário ou cancelamento definitivo do acesso, sem prejuízo de medidas legais cabíveis.</p>
`;

const UsagePolicy = () => {
  const { getPublicSetting } = useSettings();
  const [content, setContent] = useState(null);
  const [appName, setAppName] = useState("");

  useEffect(() => {
    getPublicSetting("appName").then(v => { if (v) setAppName(v); }).catch(() => {});
    api.get("/open/usage-policy")
      .then(({ data }) => setContent(data?.value || ""))
      .catch(() => setContent(""));
  }, []); // eslint-disable-line

  const scroll = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  if (content === null) return null;

  return (
    <div style={{ minHeight: "100vh", background: "#F0F9FF", display: "flex", flexDirection: "column" }}>
      <style>{`
        .legal-wrap { max-width: 900px; margin: 0 auto; padding: 104px 24px 80px; flex: 1; }
        .legal-card { background: #fff; border-radius: 24px; padding: 40px; box-shadow: 0 4px 24px rgba(0,0,0,.08); border: 1px solid rgba(79,70,229,.08); }
        .legal-card h1 { font-size: 36px; font-weight: 700; color: #1e1b4b; margin-bottom: 8px; }
        .legal-card h2 { margin-top: 32px; font-size: 22px; color: #4338ca; }
        .legal-card p, .legal-card li { color: #475467; line-height: 1.7; }
        .legal-card ul { padding-left: 20px; }
        @media (max-width: 768px) { .legal-card { padding: 24px; } .legal-card h1 { font-size: 28px; } }
      `}</style>

      <LandingHeader scrollTo={scroll} />

      <main style={{ flex: 1 }}>
        <div className="legal-wrap">
          <div className="legal-card">
            <h1>Política de Uso</h1>
            {content
              ? <div dangerouslySetInnerHTML={{ __html: content }} />
              : <div dangerouslySetInnerHTML={{ __html: DEFAULT_CONTENT }} />
            }
          </div>
        </div>
      </main>

      <LandingFooter appName={appName} />
      <VLibras />
    </div>
  );
};

export default UsagePolicy;
